module.exports = __webpack_public_path__ + "media/luxury-2026/modern-pool-drone-3ac72007.jpg";